import React from 'react';
import { Feedback } from 'services';
import { getTheme, Stack } from '@fluentui/react';
import { CaseFeedbackEntryHeader } from './CaseFeedbackEntryHeader';
import { borderBottomStyle } from '../../../../shared/BorderStyles';

interface CaseFeedbackEntryProps {
  feedback: Feedback;
}

export const CaseFeedbackEntry: React.FunctionComponent<CaseFeedbackEntryProps> = props => {
  const { palette } = getTheme();
  const borderBottom = borderBottomStyle(palette);
  return (
    <Stack className="py-3" style={borderBottom}>
      <Stack.Item className="mb-2">
        <div className="font-weight-bold mb-1">Reported by</div>
        {props.feedback.source.sourceId} / {props.feedback.source.sourceType}
      </Stack.Item>
      <Stack.Item className="mb-2">
        <CaseFeedbackEntryHeader
          userType={props.feedback.source.sourceType}
          labels={props.feedback.opinion.opinionCategoryLabels}
        />
      </Stack.Item>
      {!!props.feedback.opinion.comment && (
        <Stack.Item className="mb-2">
          <div className="font-weight-bold mb-1">Comment</div>
          {props.feedback.opinion.comment}
        </Stack.Item>
      )}
      <Stack.Item>
        <div className="font-weight-bold mb-1">Submitted </div>
        {new Date(props.feedback.feedbackDateTime).toLocaleString() || 'Unknown'} by{' '}
        {props.feedback.source.sourceId || 'Unknown'}
      </Stack.Item>
    </Stack>
  );
};

export default CaseFeedbackEntry;
